import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "WhatsApp";

export const ObterContaWhatsAppDefault = (idModulo) =>
  RequestWebApi.get(`/WhatsApp/ObterContaWhatsAppDefault/${idModulo}`)
    .then((response) => {
      const { success, resultData } = response.data;

      return {
        success,
        contaMeta: resultData ?? null,
      };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);

      const { message, errors } = error.response?.data || {};

      return {
        success: false,
        message: message || "Erro ao obter conta WhatsApp padrão.",
        errors: errors || [],
        contaMeta: null,
      };
    });

export const ObterPermissoesChatWhatsApp = () =>
  RequestWebApi.get(`/WhatsApp/ObterPermissoesChatWhatsApp`)
    .then((response) => {
      const { success, resultData } = response.data;

      return {
        success,
        permissoes: resultData ?? null,
      };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);

      const { message, errors } = error.response?.data || {};

      return {
        success: false,
        message: message || "Erro ao obter permissões do Chat WhatsApp.",
        errors: errors || [],
        permissoes: null,
      };
    });

export const ListarHistoricoMensagens = (contaMeta, ddd, numeroTelefone) =>
  RequestWebApi.get(`/${controller}/ListarHistoricoMensagens`, {
    params: { contaMeta, ddd, numeroTelefone },
  })
    .then((response) => {
      const { resultData, success } = response.data;
      return { success, mensagens: resultData };
    })
    .catch((error) => {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response?.data || {};
      return { success: false, message, errors, mensagens: null };
    });

export const EnviarMensagem = (
  contaMeta,
  numeroDestino,
  mensagem,
  idMensagemParaResponder,
) =>
  RequestWebApi.post(`/${controller}/EnviarMensagem`, {
    contaMeta,
    numeroDestino,
    idMensagemParaResponder,
    mensagem,
  })
    .then((response) => {
      const { resultData, success } = response.data;
      return { success, result: resultData };
    })
    .catch((error) => {
      const { success, message, errors } = error.response?.data || {};
      return {
        success: false,
        message: message || "Erro ao enviar mensagem.",
        errors: errors || [],
        result: null,
      };
    });

export const MarcarMensagensComoLidasPorNumero = (
  contaMeta,
  ddi,
  ddd,
  telefone,
) =>
  RequestWebApi.post(`/${controller}/MarcarMensagensComoLidasPorNumero`, {
    contaMeta,
    ddi,
    ddd,
    telefone,
  })
    .then((response) => {
      const { resultData, quantidadeAtualizada, success } = response.data;
      return {
        success,
        result: {
          lido: resultData,
          quantidadeAtualizada,
        },
      };
    })
    .catch((error) => {
      const { success, message, errors } = error.response?.data || {};
      return {
        success: false,
        message: message || "Erro ao marcar mensagens como lidas.",
        errors: errors || [],
        result: null,
      };
    });

export const EnviarMensagemComArquivo = (
  contaMeta,
  numeroDestino,
  idMensagemParaResponder,
  file,
  tipoMidia = "audio",
) => {
  const formData = new FormData();
  formData.append("contaMeta", contaMeta);
  formData.append("numeroDestino", numeroDestino);
  formData.append("idMensagemParaResponder", idMensagemParaResponder);
  formData.append("tipoMidia", tipoMidia);
  formData.append("file", file);

  return RequestWebApi.post(`/${controller}/EnviarMensagemComArquivo`, formData)
    .then((response) => {
      const { resultData, success } = response.data;
      return { success, result: resultData };
    })
    .catch((error) => {
      const { success, message, errors } = error.response?.data || {};
      return {
        success: false,
        message: message || "Erro ao enviar mídia via WhatsApp.",
        errors: errors || [],
        result: null,
      };
    });
};

export const ObterUrlMidia = (contaMeta, mediaId) => {
  if (!mediaId) return Promise.resolve({ success: false, url: null });

  return RequestWebApi.get(`/WhatsApp/DownloadMidia/${contaMeta}/${mediaId}`, {
    responseType: "blob",
  })
    .then((response) => {
      const mimeType =
        response.headers["content-type"] || "application/octet-stream";
      const blob = new Blob([response.data], { type: mimeType });
      const url = URL.createObjectURL(blob);
      return { success: true, url };
    })
    .catch((error) => {
      const { message } = error.response?.data || {};
      return {
        success: false,
        message: message || "Erro ao obter mídia.",
        url: null,
      };
    });
};

export const ObterTemplatePreviewMensagem = (mensagemId) => {
  if (!mensagemId) return Promise.resolve({ success: false, data: null });

  return RequestWebApi.get(`/WhatsApp/TemplatePreview/${mensagemId}`)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((error) => {
      const { message } = error.response?.data || {};
      return {
        success: false,
        message: message || "Erro ao obter preview do template.",
        data: null,
      };
    });
};

// GET /api/v1/WhatsApp/ListarConversasEmAndamento/{contaMeta}?usuarioId=1
export const ListarConversasEmAndamento = (contaMeta, usuarioId) => {

  return RequestWebApi.get(
    `/${controller}/ListarConversasEmAndamento/${contaMeta}`,
    { params: { usuarioId } }
  )
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};
      return {
        success: !!success,
        conversas: resultData ?? [],
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { message, errors } = error.response?.data || {};
      return {
        success: false,
        message: message || "Erro ao listar conversas em andamento.",
        errors: errors || [],
        conversas: null
      };
    });
};


// GET /api/v1/WhatsApp/ObterTotalMsgNaoLidas/{contaMeta}?usuarioId=1
export const ObterTotalMsgNaoLidas = (contaMeta, usuarioId) => {
  return RequestWebApi.get(`/${controller}/ObterTotalMsgNaoLidas/${contaMeta}`, {
    params: { usuarioId }
  })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};
      return {
        success: !!success,
        totalNaoLidas: resultData ?? 0,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { message, errors } = error.response?.data || {};
      return {
        success: false,
        message: message || "Erro ao obter total de mensagens não lidas.",
        errors: errors || [],
        totalNaoLidas: 0
      };
    });
};

export const EnviarTemplateWhatsApp = (
  contaMeta,
  numeroDestino,
  templateCodigo,
  parametros = [],
  urlImageHeader = null,
) => {
  return RequestWebApi.post(`/${controller}/EnviarTemplate`, {
    contaMeta,
    numeroDestino,
    templateCodigo,
    urlImageHeader, // opcional
    parametros, // [{ ordem: 1, valor: "..." }, ...]
  })
    .then((response) => {
      const { success, resultData, metaWhatsAppMensagemId, message, errors } =
        response.data || {};

      return {
        success: !!success,
        resultData:
          typeof resultData === "boolean" ? resultData : (resultData ?? null),
        metaWhatsAppMensagemId: metaWhatsAppMensagemId ?? null,
        message: message ?? "",
        errors: errors ?? [],
      };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);

      const data = error?.response?.data || {};
      const message = data?.message || "Erro ao enviar template WhatsApp.";
      const errors = data?.errors || [];

      return {
        success: false,
        message,
        errors,
        resultData: null,
        metaWhatsAppMensagemId: null,
      };
    });
};

export const VerificarSeCanalConversaEstaAberto = (
  contaMeta,
  ddi,
  ddd,
  telefone,
) =>
  RequestWebApi.get(`/WhatsApp/VerificarSeCanalConversaEstaAberto`, {
    params: {
      contaMeta,
      ddi,
      ddd,
      telefone,
    },
  })
    .then((response) => {
      // API retorna bool puro: true | false
      return {
        success: true,
        result: response.data,
      };
    })
    .catch((error) => {
      const { message, errors } = error.response?.data || {};

      return {
        success: false,
        message:
          message || "Erro ao verificar se o canal de conversa está aberto.",
        errors: errors || [],
        result: false,
      };
    });
